import { businessKey } from 'queryKeys';

export const CREATIVES = 'creatives';

const PERFORMANCE = 'performance';

const MUTATION_MOVE_TO_TEST = 'moveToTest';
const MUTATION_ARCHIVE = 'archive';
const MUTATION_UNARCHIVE = 'unarchive';
const MUTATION_UPLOAD = 'upload';
const MUTATION_SHARE = 'share';
const MUTATION_UNSHARE = 'unshare';
const MUTATION_EDIT = 'edit';
const MUTATION_MOVE_TO_PREVIEW = 'moveToPreview';
const MUTATION_MOVE = 'move';
const MUTATION_ACTIONS_LOG = 'actionsLog';
const MUTATION_EXPORT = 'export';
export const creativesQuery = businessKey.query(CREATIVES);

export const details = creativesQuery.details();
export const model = creativesQuery.exact();

export const grids = creativesQuery.grids();
export const grid = creativesQuery.grid();

export const performance = (id) => [CREATIVES, PERFORMANCE, id];
export const actionsLog = (id) => [CREATIVES, MUTATION_ACTIONS_LOG, id];
export const mutations = creativesQuery.mutations();

export const moveToPreview = mutations.mutate(MUTATION_MOVE_TO_PREVIEW);
export const update = mutations.update();
export const create = mutations.create();
export const remove = mutations.delete();
export const activate = mutations.activate();
export const deactivate = mutations.deactivate();

export const moveToTest = mutations.mutate(MUTATION_MOVE_TO_TEST);
export const archive = mutations.mutate(MUTATION_ARCHIVE);
export const unarchive = mutations.mutate(MUTATION_UNARCHIVE);
export const upload = mutations.mutate(MUTATION_UPLOAD);
export const share = mutations.mutate(MUTATION_SHARE);
export const unshare = mutations.mutate(MUTATION_UNSHARE);
export const edit = mutations.mutate(MUTATION_EDIT);

export const move = mutations.mutate(MUTATION_MOVE);

export const exportCreatives = mutations.mutate(MUTATION_EXPORT);
